import React from 'react'
import { Icon, Select } from '@driftt/tide-core-legacy'

import './style.styl'

const sizeOptions = [{ label: 10, value: 10 }, { label: 20, value: 20 }, { label: 30, value: 30 }]

export const decidePagination = (totalPages, currentPage) => {
  // NOTE: currentPage is 0-offset, but we want to display 1-offset for the user
  const canGoBack = currentPage > 0
  const canGoForward = currentPage + 1 < totalPages

  return {
    lastPage: totalPages,
    currentPage: currentPage + 1,
    canGoBack,
    canGoForward,
  }
}

export const Paginator = ({ totalPages, index, goForward, goBackward, changeSize, size }) => {
  const {
    lastPage,
    canGoBack,
    canGoForward,
    currentPage,
  } = decidePagination(totalPages, index)

  return (
    <div className="playbook-list-table-paginator">
      <Select options={sizeOptions} clearable={false} value={size} onChange={changeSize} className="playbook-list-table-paginator-size-select" />
      <div className="paginator-navigation">
        {canGoBack && <button className="playbook-list-table-arrow paginate-direction-left" onClick={goBackward}><Icon width={12} height={12} name="arrow-1-left" /></button>}
        {lastPage !== 0 &&
          <span className="paginator-navigation-page">page {currentPage} of {lastPage}</span>
        }
        {canGoForward && <button className="playbook-list-table-arrow paginate-direction-right" onClick={goForward}><Icon width={12} height={12} name="arrow-1-right" /></button>}
      </div>
    </div>
  )
}

export default Paginator



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/Paginator/index.js